/**
 * Advertisement
 */
export { default as checkMark } from "./advertisement/checkMark.png";

/**
 * Placeholders
 */
export { default as annaProfile } from "./placeholders/annaProfile.png";
export { default as homePlaceholder } from "./placeholders/homePlaceholder.png";
export { default as madissaia } from "./placeholders/madissaia.webp";
export { default as profilePlaceholder1 } from "./placeholders/profile1.png";
export { default as profilePlaceholder2 } from "./placeholders/profile2.png";
export { default as profilePlaceholder3 } from "./placeholders/profile3.png";
export { default as profilePlaceholder } from "./placeholders/profilePlaceholder.png";
export { default as workerAnna } from "./placeholders/workerAnna.png";

/**
 * Socials
 */
export { default as apple } from "./socials/apple.png";
export { default as facebook } from "./socials/facebook.png";
export { default as google } from "./socials/google.png";
